import { createBusinessLogger } from '@/utils/logger/businessLogger';
import { AllowedBusinessLoggerKey } from '@/utils/logger/businessLogger/constants';

/**
 * 地址模块监控
 */
export const ADDRESS_EVENT_NAMES = {
  // 国家
  COUNTRY_DATA_INIT_ERROR: 'address_country_data_init_error', // 国家初始化异常
  COUNTRY_SWITCH_ERROR: 'address_country_switch_error', // 国家切换异常

  // 语言
  LANGUAGE_SWITCH_ERROR: 'address_language_switch_error', // 语言切换异常

  // 货币
  CURRENCY_SWITCH_ERROR: 'address_currency_switch_error', // 货币切换异常

  // 定位
  LOCATION_GET_ERROR: 'address_location_get_error', // 获取定位异常

  // 地图
  MAP_RENDER_ERROR: 'address_map_render_error', // 地图渲染异常

  // 地址数据
  ADDRESS_LIST_QUERY_ERROR: 'address_list_query_error', // 地址列表查询异常
  PICKUP_LIST_QUERY_ERROR: 'address_pickup_list_query_error', // 自提列表查询异常
  ADDRESS_EDIT_ERROR: 'address_edit_error', // 地址编辑异常

  // 全局地址
  GLOBAL_ADDRESS_CACHE_ERROR: 'address_global_cache_error', // 设置全局地址缓存异常
  GLOBAL_ADDRESS_DELIVERY_UNSUPPORTED: 'address_delivery_unsupported', // 全局地址不支持配送
} as const;

export type AddressEventNames = typeof ADDRESS_EVENT_NAMES;

export const ADDRESS_CATEGORY_VALUES = {
  MODULE: {
    LAYOUT: 'layout',
    HEADER: 'header',
    FOOTER: 'footer',
    BILLING: 'billing',
    ADDRESS_MANAGE: 'addressManage',
    ADDRESS_SELECT: 'addressSelect',
    ADDRESS_CREATE: 'addressCreate',
    AFTER_SALES: 'afterSales'
  },

  ACTION: {
    REQUEST: 'request',
    SET_COOKIE: 'setCookie'
  },

  RESULT: {
    SUCCESS: 'success',
    ERROR: 'error',
    TIMEOUT: 'timeout',
    LOG: 'log'
  },
} as const;


const ADDRESS_LOGGER_KEY: AllowedBusinessLoggerKey = 'address';

type AddressCategoryKeys = keyof typeof ADDRESS_CATEGORY_VALUES;
const categoryNames: Lowercase<AddressCategoryKeys>[] = ['module', 'action', 'result'];

/**
 * 地址业务监控实例
 */
export const addressBusinessLogger = createBusinessLogger<AddressEventNames>(
  ADDRESS_LOGGER_KEY,
  categoryNames,
);
